// extracted by mini-css-extract-plugin
export default {"placeholder":"MaybePlaceholder_placeholder__USkLR","paragraph":"MaybePlaceholder_paragraph__bM-z+","link":"MaybePlaceholder_link__VhtA4"};